import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://72c322e1e4c56831234c3044e478b71d@us.sentry.io/4506815662915584',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      blockAllMedia: false,
      maskAllText: false,
    }),
  ],
  // Session Replay
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.

  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled.
  // If you want to test locally or on staging add 'localhost' or /^https:\/\/staging\.literably\.com/ to below
  tracePropagationTargets: [/^https:\/\/literably\.com/],
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
});
